import * as React from "react";
const SvgFiRrScript = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-script_svg__a)">
      <path
        fill="#062147"
        d="M12 9.414V11a1 1 0 0 0 1 1h1.586a3.97 3.97 0 0 0 2.828-1.172l5.707-5.707a3 3 0 0 0 0-4.242 3 3 0 0 0-4.242 0l-5.707 5.707A3.97 3.97 0 0 0 12 9.414m2 0c0-.534.208-1.036.586-1.414l5.707-5.707a.999.999 0 1 1 1.414 1.414L16 9.414c-.378.378-.88.586-1.414.586H14zM21 17h-1v-3a1 1 0 1 0-2 0v3h-5c-1.654 0-3 1.346-3 3v.5c0 .827-.673 1.5-1.5 1.5S7 21.327 7 20.5v-17c0-.539-.133-1.044-.351-1.5H14a1 1 0 1 0 0-2H3.5C1.57 0 0 1.57 0 3.5V4c0 1.654 1.346 3 3 3h2v13.5A3.503 3.503 0 0 0 8.498 24H20.5c1.93 0 3.5-1.57 3.5-3.5V20c0-1.654-1.346-3-3-3M5 5H3a1 1 0 0 1-1-1v-.5C2 2.673 2.673 2 3.5 2S5 2.673 5 3.5zm17 15.5c0 .827-.673 1.5-1.5 1.5h-8.838c.217-.455.338-.964.338-1.5V20a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-script_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrScript;
